import * as React from 'react'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import {
    UIRecoveryPasswordFormSchema,
    transformErrors,
    getRecoveryPasswordFormSchema
} from '../../../Model/RecoveryPasswordForm'
import { Button } from 'react-bootstrap'
import LocalizationStore from '../../../Stores/LocalizationStore'
import HttpActionsService from '../../../Services/HttpActionsService'
import { withRouter } from 'react-router'
import { observer } from 'mobx-react'

export interface IRecoveryPasswordPageProps {
}

@observer
class RecoveryPasswordPage extends React.Component<IRecoveryPasswordPageProps> {

    constructor(props: any) {
        super(props)
    }

    uiSchema: any = UIRecoveryPasswordFormSchema

    recover(e: ISubmitEvent<any>): void {
        HttpActionsService.getInstance().recoverPassword(e.formData)
    }

    render() {
        const self = this
        const ls = LocalizationStore.getInstance()
        const { email, code } = this.props['match']!['params']
        return (
            <div className="recoveryPasswordPage">
                <Form
                    onSubmit={(e) => self.recover(e)}
                    schema={getRecoveryPasswordFormSchema(email, code)}
                    uiSchema={this.uiSchema}
                    transformErrors={transformErrors}
                >
                    <Button type="submit">{ls.t!('RecoverPasswordBtn')}</Button>
                </Form>
            </div>
        )
    }

}

export default withRouter(RecoveryPasswordPage)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/Pages/Account/RecoveryPasswordPage.tsx